import type { Industry } from '@nestjs-boilerplate/types';

export const LEGAL_PROFESSIONALS_TEXT =
  'You must carry out a client and matter risk assessment under Regulation 28(12) & (13) of the Money Laundering, Terrorist Financing and Transfer of Funds (Information on the Payer) Regulations 2017. Optimal KYC will help you to meet your obligations in the following areas:';

export const OTHER_INDUSTRIES_TEXT =
  'Depending on your industry and the nature of the transaction, you may be subject to the UK Money Laundering, Terrorist Financing and Transfer of Funds (Information on the Payer) Regulations 2017. Optimal KYC will help you to comply with those obligations. Optimal KYC will help you to meet your obligations in the following areas:';

// Industries that fall under legal professional regulations
const LEGAL_INDUSTRIES: Industry[] = ['SOLICITORS', 'TCSPS'];

export function getRegulatoryText(industry?: Industry | null): string {
  // Default to SOLICITORS text if no industry specified (main use case)
  if (!industry) {
    return LEGAL_PROFESSIONALS_TEXT;
  }

  // Legal professionals get the Regulation 28(12) & (13) text
  if (LEGAL_INDUSTRIES.includes(industry)) {
    return LEGAL_PROFESSIONALS_TEXT;
  }

  // Other regulated industries get the general AML text
  return OTHER_INDUSTRIES_TEXT;
}
